import { render, staticRenderFns } from "./salesStockReturn.vue?vue&type=template&id=6890536e&scoped=true"
import script from "./salesStockReturn.vue?vue&type=script&lang=js"
export * from "./salesStockReturn.vue?vue&type=script&lang=js"
import style0 from "./salesStockReturn.vue?vue&type=style&index=0&id=6890536e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6890536e",
  null
  
)

export default component.exports